import type { ReactNode } from "react";
import React, { useEffect } from "react";
import { ContentContainer, OverlayWrapper, MenuWrapper } from "./style";

type Props = {
  isOpen: boolean;
  handleClose(): void;
  children: ReactNode;
};

const OverlayMenu = ({
  isOpen,
  handleClose,
  children
}: Props): JSX.Element | null => {
  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) =>
      event.code === "Escape" && handleClose();
    window.addEventListener("keydown", handleEsc);
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [handleClose]);

  return (
    <OverlayWrapper isOpen={isOpen}>
      <MenuWrapper isOpen={isOpen}>
        <ContentContainer>{children}</ContentContainer>
      </MenuWrapper>
    </OverlayWrapper>
  );
};

export default OverlayMenu;
